import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import { MailroomOptions } from "../../models/SchoolMailroomConfigDto";
import { Toggle } from "office-ui-fabric-react";
import * as _ from 'lodash';

export interface SalamanderOptionsEditorProps {
    options?: MailroomOptions;
    onOptionsChanged(newOptions: MailroomOptions): void;
    disabled: boolean;
}

export interface SalamanderOptionsEditorState {

}

class SalamanderOptionsEditor extends Component<SalamanderOptionsEditorProps & DispatchProps, SalamanderOptionsEditorState> {

    constructor(props: SalamanderOptionsEditorProps & DispatchProps) {
        super(props);

        this.state = {};
    }

    public async componentDidMount() {

    }

    public componentDidUpdate(prevProps: Readonly<SalamanderOptionsEditorProps & DispatchProps>, prevState: Readonly<SalamanderOptionsEditorState>, snapshot?: any) {


    }

    private buildOptions() {
        if (this.props.options !== undefined) {
            
            const checkBoxes = Object.keys(this.props.options).filter(v => v !== "$type").map((optionName) => {
                
                if (this.props.options !== undefined) {
                    return (<Toggle
                        key={optionName}
                        label={optionName}
                        disabled={this.props.disabled}
                        checked={this.props.options[optionName]}
                        inlineLabel
                        onChange={(e, checked) => this.onOptionChanged(optionName, checked)} />);
                }
            });

            return (
                <Fragment>
                    {checkBoxes}
                </Fragment>
            )
        }
        else {
            return (<div>No Options Available</div>)
        }
    }

    private onOptionChanged(optionName: string, checked: boolean | undefined): void {
        if (this.props.options !== undefined && checked !== undefined) {
            this.props.options[optionName] = checked;

            let newOptions = _.cloneDeep(this.props.options)

            this.props.onOptionsChanged(newOptions);
            this.forceUpdate();
        }
    }

    public render() {
        return (
            <Fragment>
                {this.buildOptions()}
            </Fragment>
        );
    }
}


export default connect(
    (state: IRootState, ownProps: { disabled: boolean, options?: MailroomOptions, onOptionsChanged(newOptions: MailroomOptions): void }): SalamanderOptionsEditorProps => {

        return {
            options: ownProps.options,
            onOptionsChanged: ownProps.onOptionsChanged,
            disabled: ownProps.disabled
        };
    }
)(SalamanderOptionsEditor);
